import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
const Login = () => {
  const history = useHistory()
  const [identifier, setIdentifier] = useState('')
  const [password, setPassword] = useState('')
  const { login, isLoggedIn, user } = useAuth()

  useEffect(() => {
    const loggedIn = isLoggedIn()
    if (loggedIn) {
      history.replace( '/waitingroom')
    }
  }, [history, isLoggedIn, user])

  const onSubmit = (e) => {
    e.preventDefault()
    login({identifier, password})
  }

  return (
    <div>
      <h1>Rühms</h1>
      <form action="">
        <input type="email" onChange={(e) => setIdentifier(e.target.value)} />
        <input type="password" onChange={(e) => setPassword(e.target.value)} />
        <button onClick={onSubmit} >Login</button>
      </form>
    </div>
  )
}

export default Login